import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faShieldAlt,
  faUserShield,
  faKey,
  faEraser,
  faFileExport,
  faBan,
  faBalanceScale,
  faFileAlt,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";


const GDPR = () => {
  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
                   <section className='section-about-1'>
                       <div>
                           <h3 className='align-about-ab'>
             <span className='acasa-about-footer'>Acasa</span>
             <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
           
             <span className='color-despre'>Protecția Datelor</span>
           </h3>
                       </div>
                     
                     
                   </section>


                     <div className='tittle-ab-top'>
                        <h4>Protecția Datelor Personale (GDPR)</h4>
                    </div>
           
                   
           
                {/* Introducere GDPR */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce este GDPR?</h4>
    <p>
      Regulamentul General privind Protecția Datelor (GDPR - General Data Protection Regulation) este o legislație europeană 
      care protejează drepturile și libertățile persoanelor în ceea ce privește prelucrarea datelor cu caracter personal.
    </p>
    <p>
      La ContaLearn, respectăm pe deplin prevederile GDPR și ne angajăm să protejăm datele tale personale cu cea mai mare grijă.
    </p>
    <p><strong>Data aplicării:</strong> 25 mai 2018</p>
  </div>
</section>

{/* Drepturile tale conform GDPR */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Drepturile tale conform GDPR</h4>
    <p>
      În conformitate cu GDPR, ai următoarele drepturi fundamentale:
    </p>
    <ul style={{marginTop: '15px'}}>
      <li style={{marginBottom: '10px'}}>
        <strong>🔍 Dreptul de acces (Art. 15 GDPR)</strong> — Poți solicita informații despre datele personale pe care le procesăm despre tine
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>✏️ Dreptul de rectificare (Art. 16 GDPR)</strong> — Poți cere corectarea datelor inexacte sau completarea datelor incomplete
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🗑️ Dreptul la ștergerea datelor (Art. 17 GDPR)</strong> — "Dreptul de a fi uitat" - poți solicita ștergerea datelor tale
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>⏸️ Dreptul la restricționarea prelucrării (Art. 18 GDPR)</strong> — Poți limita modul în care folosim datele tale
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>📦 Dreptul la portabilitatea datelor (Art. 20 GDPR)</strong> — Poți primi datele tale într-un format structurat și portabil
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🚫 Dreptul de opoziție (Art. 21 GDPR)</strong> — Te poți opune prelucrării datelor tale în anumite condiții
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🤖 Dreptul de a nu fi supus deciziilor automate (Art. 22 GDPR)</strong> — Protecție împotriva profilării automate
      </li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserShield} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul de acces */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faKey} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de acces la date (Art. 15 GDPR)</h4>
    <p>
      Ai dreptul să obții de la ContaLearn o confirmare că prelucrăm sau nu date cu caracter personal care te privesc 
      și, în caz afirmativ, acces la acestea.
    </p>
    <p><strong>Ce poți solicita:</strong></p>
    <ul>
      <li>▸ O copie a datelor personale</li>
      <li>▸ Scopurile prelucrării</li>
      <li>▸ Categoriile de date prelucrate</li>
      <li>▸ Destinatarii datelor tale</li>
      <li>▸ Perioada de stocare a datelor</li>
      <li>▸ Existența drepturilor GDPR</li>
    </ul>
    <p><strong>Termen de răspuns:</strong> Maximum 30 zile de la solicitare</p>
  </div>
</section>

{/* Dreptul la stergere */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Dreptul la ștergerea datelor - "Dreptul de a fi uitat" (Art. 17 GDPR)</h4>
    <p>
      Poți solicita ștergerea datelor tale personale în următoarele situații:
    </p>
    <ul>
      <li>✓ Datele nu mai sunt necesare pentru scopurile pentru care au fost colectate</li>
      <li>✓ Îți retragi consimțământul și nu există alt temei legal pentru prelucrare</li>
      <li>✓ Te opui prelucrării și nu există motive legitime care să prevaleze</li>
      <li>✓ Datele au fost prelucrate ilegal</li>
      <li>✓ Datele trebuie șterse pentru respectarea unei obligații legale</li>
    </ul>
    <p><strong>Excepții:</strong> Nu putem șterge datele dacă prelucrarea este necesară pentru:</p>
    <ul>
      <li>▸ Respectarea unei obligații legale</li>
      <li>▸ Constatarea, exercitarea sau apărarea unui drept în instanță</li>
      <li>▸ Motive de interes public în domeniul sănătății publice</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEraser} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul la portabilitate */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileExport} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul la portabilitatea datelor (Art. 20 GDPR)</h4>
    <p>
      Ai dreptul să primești datele personale pe care ni le-ai furnizat într-un format structurat, utilizat în mod curent 
      și care poate fi citit automat (de exemplu: JSON, CSV, XML).
    </p>
    <p><strong>Ce include:</strong></p>
    <ul>
      <li>▸ Datele pe care le-ai furnizat direct (nume, email, etc.)</li>
      <li>▸ Datele generate prin utilizarea platformei (progres, răspunsuri, rezultate)</li>
    </ul>
    <p>
      De asemenea, poți solicita transmiterea directă a acestor date către alt operator, unde este posibil din punct de vedere tehnic.
    </p>
  </div>
</section>

{/* Dreptul de opozitie */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Dreptul de opoziție (Art. 21 GDPR)</h4>
    <p>
      Te poți opune oricând, din motive legate de situația ta particulară, ca datele tale să fie prelucrate pe baza:
    </p>
    <ul>
      <li>▸ Interesului legitim al ContaLearn (Art. 6(1)(f) GDPR)</li>
      <li>▸ Interesului public (Art. 6(1)(e) GDPR)</li>
    </ul>
    <p><strong>Marketing direct:</strong></p>
    <p>
      Te poți opozi oricând și necondiționat prelucrării datelor tale în scopuri de marketing direct. 
      În acest caz, vom înceta imediat prelucrarea pentru aceste scopuri.
    </p>
    <p><strong>Cum te poți opune:</strong></p>
    <ul>
      <li>▸ Prin setările contului tău</li>
      <li>▸ Prin click pe "Dezabonare" din email-urile noastre</li>
      <li>▸ Prin solicitare la suport@contalearn.ro</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBan} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Baze legale */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBalanceScale} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Bazele legale ale prelucrării (Art. 6 GDPR)</h4>
    <p>
      Prelucrăm datele tale personale numai pe baze legale conforme GDPR:
    </p>
    <ul style={{marginTop: '15px'}}>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(a) - Consimțământ</strong><br />
        Ai dat consimțământul pentru prelucrarea datelor (ex: newsletter, marketing)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(b) - Executarea contractului</strong><br />
        Prelucrarea este necesară pentru executarea contractului (ex: furnizarea cursurilor)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(c) - Obligație legală</strong><br />
        Prelucrarea este necesară pentru respectarea unei obligații legale (ex: evidență contabilă)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(f) - Interes legitim</strong><br />
        Prelucrarea este necesară pentru un interes legitim (ex: prevenirea fraudelor, îmbunătățirea platformei)
      </li>
    </ul>
  </div>
</section>

{/* Cum exerciti drepturile */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cum îți exerciți drepturile GDPR?</h4>
    <p>
      Pentru a-ți exercita oricare dintre drepturile enumerate mai sus, ne poți contacta prin:
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <p style={{margin: '5px 0'}}><strong>📧 Email:</strong> suport@contalearn.ro</p>
      <p style={{margin: '5px 0'}}><strong>📝 Subiect:</strong> "Solicitare GDPR - [tipul dreptului]"</p>
    </div>
    <p style={{marginTop: '15px'}}><strong>Ce trebuie să incluzi în solicitare:</strong></p>
    <ul>
      <li>▸ Numele complet</li>
      <li>▸ Adresa de email asociată contului</li>
      <li>▸ Descrierea clară a dreptului pe care vrei să-l exerciți</li>
      <li>▸ Documentul de identitate (pentru verificarea identității)</li>
    </ul>
    <p style={{marginTop: '15px'}}>
      <strong>Termen de răspuns:</strong> Vom răspunde solicitării tale în maximum <strong>30 zile</strong> de la primire. 
      În cazuri complexe, putem prelungi termenul cu încă 60 zile, informându-te în acest sens.
    </p>
    <p style={{marginTop: '10px'}}>
      <strong>Costuri:</strong> De regulă, exercitarea drepturilor este <strong>gratuită</strong>. 
      În cazuri excepționale (solicitări manifestă nefondate sau excesive), ne rezervăm dreptul de a percepe o taxă rezonabilă.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Plangeri */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBalanceScale} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de a depune plângere</h4>
    <p>
      Dacă consideri că drepturile tale GDPR au fost încălcate, ai dreptul să depui o plângere la autoritatea de supraveghere:
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <h4 style={{margin: '0 0 10px 0', color: '#13b8ab'}}>🇷🇴 Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</h4>
      <p style={{margin: '5px 0'}}><strong>📍 Adresă:</strong> B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București</p>
      <p style={{margin: '5px 0'}}><strong>📞 Telefon:</strong> +40 318 059 211 / +40 318 059 212</p>
      <p style={{margin: '5px 0'}}><strong>📧 Email:</strong> anspdcp@dataprotection.ro</p>
      <p style={{margin: '5px 0'}}><strong>🌐 Website:</strong> <a href='https://www.dataprotection.ro/' target='_blank' rel='noopener noreferrer'>www.dataprotection.ro</a></p>
    </div>
    <p style={{marginTop: '15px'}}>
      Cu toate acestea, te încurajăm să ne contactezi mai întâi la <strong>suport@contalearn.ro</strong> pentru a încerca să rezolvăm situația direct.
    </p>
  </div>
</section>

{/* Contact */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Contact pentru GDPR</h4>
    <p>
      Pentru orice întrebări legate de protecția datelor personale sau exercitarea drepturilor GDPR, contactează-ne:
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <p style={{margin: '5px 0'}}><strong>📩 Email:</strong> suport@contalearn.ro</p>
      <p style={{margin: '5px 0'}}><strong>📝 Subiect:</strong> "GDPR - Protecția Datelor"</p>
    </div>
    <p style={{marginTop: '15px'}}>
      Suntem aici pentru a proteja datele tale și pentru a-ți respecta toate drepturile conform legislației GDPR.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

           
            <div className='line-about'></div>
           
                 
           
                 </div>
               </div>
   
  );
};

export default GDPR;
